import styles from "./indicatorSettings.module.styl";

export const percentageLevels = {
    normal: 50,
    good: 75,
    maximum: 100,

    badStyle: {
        color: "#E8333A",
        style: styles.redBorder,
        colorName: "red",
        textStyle: styles.redText,
        backgroundStyle: styles.redBackground,
        lightBackgroundStyle: styles.lightRedBackground,
        leftBorderStyle: styles.redLeftBorder,
        loadingText: "низкий уровень загрузки",
    },
    normalStyle: {
        color: "#FB9145",
        style: styles.yellowBorder,
        colorName: "yellow",
        textStyle: styles.yellowText,
        backgroundStyle: styles.yellowBackground,
        lightBackgroundStyle: styles.lightYellowBackground,
        leftBorderStyle: styles.yellowLeftBorder,
        loadingText: "средний уровень загрузки",
    },
    goodStyle: {
        color: "#78C962",
        style: styles.greenBorder,
        colorName: "green",
        textStyle: styles.greenText,
        backgroundStyle: styles.greenBackground,
        lightBackgroundStyle: styles.lightGreenBackground,
        leftBorderStyle: styles.greenLeftBorder,
        loadingText: "высокий уровень загрузки",
    },
    noStyle: {
        color: "#082254",
        style: styles.grayBorder,
        colorName: "gray",
        textStyle: styles.grayText,
        backgroundStyle: styles.grayBackground,
        lightBackgroundStyle: styles.lightGrayBackground,
        leftBorderStyle: styles.grayLeftBorder,
        loadingText: "недостаточно данных",
    },
    overLoad: {
        color: "#E8333A",
        style: styles.redBorder,
        colorName: "red",
        textStyle: styles.redText,
        backgroundStyle: styles.redBackground,
        lightBackgroundStyle: styles.lightRedBackground,
        leftBorderStyle: styles.redLeftBorder,
        loadingText: "перегрузка",
    },

    indicatorColor: function (value) {
        return value == null
            ? this.noStyle
            : value >= this.normal
            ? value >= this.good
                ? this.goodStyle
                : this.normalStyle
            : this.badStyle;
    },

    indicatorColorWithOverload: function (value) {
        return value == null
            ? this.noStyle
            : value > this.maximum
            ? this.overLoad
            : value < this.normal
            ? this.badStyle
            : value >= this.good
            ? this.goodStyle
            : this.normalStyle;
    },
};
